import { useQuery } from "@tanstack/react-query";
import { inventoryTemplatesApi } from "./inventory-templates.api";
import { inventoryTemplatesKeys } from "./keys";

export const useGetActiveInventoryTemplates = () => {
  return useQuery({
    queryKey: inventoryTemplatesKeys.active(),
    queryFn: () => inventoryTemplatesApi.getActive(),
  });
};

export const useGetInventoryTemplates = (params?: any) => {
  return useQuery({
    queryKey: inventoryTemplatesKeys.list(params),
    queryFn: () => inventoryTemplatesApi.getAll(params),
  });
};
